// Header.tsx
import { styled } from "@mui/material";
import React from "react";

const StyledHeader = styled("div")({
  textAlign: "center",
  marginTop: "10px",
  position: "relative",
});

const Logo = styled("img")({
  width: "100px",
  zIndex: 1,
  marginTop: 10,
});

const Header: React.FC = () => {
  return (
    <StyledHeader>
      <Logo
        src="https://flanerie-skincare.com/cdn/shop/files/flanerie-logo-1649686248_e5f83701-9350-4533-85b9-c753c4a0873a.webp?v=1740495377&width=100"
        alt="logo"
      />
    </StyledHeader>
  );
};

export default Header;
